import { Injectable, OnInit } from '@angular/core';
import { IDataService } from '../data-services/data-service.interface';
import { DataService } from '../data-services/data.service';

export interface Note {
  content: string;
  hearts: number;
  id?: string;
}

@Injectable({
  providedIn: 'root'
})
export class NoteService extends DataService<Note> implements OnInit {
  protected collectionname = 'notes';
  protected _relativeUrl = 'notes';

  ngOnInit(): void {
    this.setCollectionName('notes');
  }
}
